import { merge } from "lodash-es"
import {
  DIGITAL_ASSET_FUND_CONVERSION_DESER,
  DigitalAssetFundConversion,
} from "../../tastyworks/digital-asset-fund-conversion"
import type HttpClient from "../../tastyworks/http"
import type { PaginationParams } from "../../tastyworks/request"
import {
  BaseResponse,
  parseErrorContainer,
  type ItemsResponse,
} from "../../tastyworks/response"

export class DigitalAssetFundConversionService {
  constructor(private readonly accountNumberClient: HttpClient) {}

  readonly index = async (
    accountNumber: string,
    params?: PaginationParams,
    id?: string[]
  ): Promise<ItemsResponse<DigitalAssetFundConversion>> =>
    this.accountNumberClient.indexSimple(
      DIGITAL_ASSET_FUND_CONVERSION_DESER.toParser(DigitalAssetFundConversion),
      "/digital-asset-fund-conversions",
      merge({ accountNumber }, { ...params, id })
    )

  readonly abandon = async (
    accountNumber: string,
    token: string,
    digitalAssetCustomerAddressId: number
  ) => {
    const helper = await this.accountNumberClient.postJson(
      "/digital-asset-fund-conversions/abandoned",
      {
        token,
        "digital-asset-customer-address-id": digitalAssetCustomerAddressId,
      },
      { accountNumber }
    )

    const response = new BaseResponse()
    parseErrorContainer(helper, response)

    return response
  }
}
